export const SITE_LOGO = "https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/c5tmpjar_Untitled129.png";

export const AdPlaceholder = ({ vertical, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`group w-full h-full flex items-center justify-center gap-3 rounded-lg border border-dashed border-white/15 bg-white/[0.03] hover:bg-white/[0.06] hover:border-primary/50 transition-colors text-center px-3 ${vertical ? 'flex-col' : 'flex-row'}`}
  >
    <img src={SITE_LOGO} alt="Dragon TV" className={`${vertical ? 'w-14 h-14' : 'w-8 h-8 sm:w-10 sm:h-10'} object-contain opacity-80 group-hover:opacity-100 transition-opacity`} />
    <div className={vertical ? '' : 'text-left'}>
      <div className="font-heading uppercase italic text-white text-sm sm:text-base leading-tight">
        Dragon <span className="text-primary">TV</span>
      </div>
      <div className="text-[11px] sm:text-xs text-gray-400 group-hover:text-gray-200 transition-colors">Your ad could be here</div>
    </div>
  </button>
);
